/**
 * Asynchronously loads the component for NotificationPage
 */

import { lazyLoad } from "@utils/loadable";

export const NotificationPage = lazyLoad(
  () => import("./index"),
  (module) => module.NotificationPage
);
